module.exports = __webpack_public_path__ + "static/media/26.b208c211.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/26.svg
// module id = 137
// module chunks = 0